import { FC, ReactNode } from 'react';
import styles from './TransportAccessibility.css';

interface ITransportAccessibilityProps {
  items: ReactNode;
}

export const TransportAccessibility: FC<ITransportAccessibilityProps> = ({ items }) => {
  return <div className={styles['container']}>{items}</div>;
};
